// Mirrors @designwithfriends/ingestion-pipeline src/common/item-type.ts.
// (common is types-only, so the runtime list is duplicated here.)
// Step-4 modelling path for model item types (mirrors MODEL_ENGINES in the pipeline).
export const MODEL_ENGINES = [
    { value: 'opus', label: 'Opus builder' },
    { value: 'meshy', label: 'Meshy' },
];

// Mirrors MODEL_ITEM_TYPES in the pipeline: types whose asset is a 3D model.
export const MODEL_ITEM_TYPES = ['FloorItem', 'WallItem', 'Door', 'Crib', 'ToddlerBed', 'TwinBed', 'QueenBed', 'Bassinet'];

export const ITEM_TYPES = [
    'Color',
    'FloorItem',
    'WallItem',
    'Door',
    'Texture',
    'WallPrint',
    'Crib',
    'ToddlerBed',
    'TwinBed',
    'QueenBed',
    'Bassinet',
    'Pillow',
    'Rug',
    'Curtain',
];

// Mirrors BED_ITEM_TYPES in the pipeline: modeled as bare frames, bedding added in the model editor.
export const BED_TYPES = ['Crib', 'ToddlerBed', 'TwinBed', 'QueenBed', 'Bassinet'];
export const isBedType = (itemType) => BED_TYPES.includes(itemType);

export const PIPELINE_STEPS = [
    { step: 1, title: 'Variations' },
    { step: 2, title: 'Scrape' },
    { step: 3, title: 'Extract' },
    { step: 4, title: 'Assets' },
    { step: 5, title: 'Compress' },
    { step: 6, title: 'Confirm' },
];

// Status-group filter options for the /ingestion list (mirrors backend statusGroup).
export const STATUS_GROUP_OPTIONS = [
    { value: 'all', label: 'All statuses' },
    { value: 'manual', label: 'Needs manual work' },
    { value: 'in_progress', label: 'In progress' },
    { value: 'failed', label: 'Failed' },
    { value: 'rejected', label: 'Rejected' },
];

export const SORT_OPTIONS = [
    { value: 'createdAt', label: 'Newest created' },
    { value: 'updatedAt', label: 'Recently updated' },
];

export const STATUS_LABELS = {
    draft: { text: 'Draft', color: 'default' },
    running: { text: 'Running', color: 'processing' },
    needs_input: { text: 'Needs input', color: 'warning' },
    needs_manual_fix: { text: 'Needs manual fix', color: 'warning' },
    failed_to_fetch: { text: 'Failed to fetch', color: 'error' },
    failed: { text: 'Failed', color: 'error' },
    rejected: { text: 'Rejected', color: 'error' },
    ready_to_publish: { text: 'Ready to publish', color: 'success' },
    published_hidden: { text: 'Published (hidden)', color: 'error' },
    published: { text: 'Published', color: 'success' },
};
